export enum adminApplicantsPostTypes {
    FETCH_ADMIN_APPLICANTS_POST_REQUEST = "FETCH_ADMIN_APPLICANTS_POST_REQUEST",
    FETCH_ADMIN_APPLICANTS_POST_SUCCESS = "FETCH_ADMIN_APPLICANTS_POST_SUCCESS",
    FETCH_ADMIN_APPLICANTS_POST_FAILURE = "FETCH_ADMIN_APPLICANTS_POST_FAILURE",
  }